import { CommandDispatcher } from "@/modules/shared/domain/CommandDispatcher";

export class RestoreConfigurationCompanyCommand {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly frontend,
  ) {}

  async run(company_id: number, setting_code: string = 'excel_headers'): Promise<void> {
    let args = {
      company_id: company_id,
      setting_code: setting_code
    }
    await this.dispatcher.dispatch('restore.configuration.company', args)
  }
}
